// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UmmpNhz1cfPf7kSdsdka {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 5.75rem 0;
  grid-gap: 2.5rem;
  gap: 2.5rem;
}

.fSvvRGktO_uzz6iTmm7i {
  margin-top: 2.5rem;
}

.nfHaAkeZMt2SUpGpeCrx,
.L1fRj8VVzKfYZxD2hmHa {
  display: block;
}

.kPF1v3fzMkyja7ZLmoEq {
  min-width: 2.5rem;
}

.ImIU6xLoN8BSQUxDK7mO {
  font-weight: 600;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .fSvvRGktO_uzz6iTmm7i {
    margin-top: 1.875rem;
  }

  .UmmpNhz1cfPf7kSdsdka {
    display: block;
    margin: 3.125rem 0;
  }

  .nfHaAkeZMt2SUpGpeCrx {
    margin-top: 3.125rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .fSvvRGktO_uzz6iTmm7i {
    margin-top: 1rem;
  }

  .UmmpNhz1cfPf7kSdsdka {
    display: block;
    margin: 2.5rem 0;
  }

  .nfHaAkeZMt2SUpGpeCrx {
    margin-top: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessTopBlock/BusinessTopBlock.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAc;EACd,gBAAS;EAAT,WAAS;AACX;;AAEA;EACE,kBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EACE;IACE,oBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAc;EAChB;;EAEA;IACE,oBAAgB;EAClB;AACF;;AAEA;;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAc;EAChB;;EAEA;IACE,kBAAgB;EAClB;AACF","sourcesContent":[".businessTopBlock {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin: 92px 0;\n  gap: 40px;\n}\n\n.usps {\n  margin-top: 40px;\n}\n\n.rightColumn,\n.leftColumn {\n  display: block;\n}\n\n.uspItemImage {\n  min-width: 40px;\n}\n\n.uspItemText {\n  font-weight: 600;\n}\n\n@media (--tablet) {\n  .usps {\n    margin-top: 30px;\n  }\n\n  .businessTopBlock {\n    display: block;\n    margin: 50px 0;\n  }\n\n  .rightColumn {\n    margin-top: 50px;\n  }\n}\n\n@media (--mobile) {\n  .usps {\n    margin-top: 16px;\n  }\n\n  .businessTopBlock {\n    display: block;\n    margin: 40px 0;\n  }\n\n  .rightColumn {\n    margin-top: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"businessTopBlock": `UmmpNhz1cfPf7kSdsdka`,
	"usps": `fSvvRGktO_uzz6iTmm7i`,
	"rightColumn": `nfHaAkeZMt2SUpGpeCrx`,
	"leftColumn": `L1fRj8VVzKfYZxD2hmHa`,
	"uspItemImage": `kPF1v3fzMkyja7ZLmoEq`,
	"uspItemText": `ImIU6xLoN8BSQUxDK7mO`
};
export default ___CSS_LOADER_EXPORT___;
